import { EventAvailable } from "@mui/icons-material";
import { Box, Button, Divider, Paper, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import TitleWithIcon from "../../../../components/display/TitleWithIcon";
import { ThemeContext } from "../../../../contexts/ThemeContext";
import { PENDING_APPOINTMENTS } from "../../../../enums/UrlPaths";
import { useGetPendingAppointmentsLimit } from "../../../../hooks/usePendingAppointments";
import PendingAppointmentsHomePage from "../PendingAppointmentsHomePage";

export default function PendingSidebar() {
  const {
    appointments,
    count,
    isLoading: loading,
    error,
    refetch,
  } = useGetPendingAppointmentsLimit();

  const { mode } = useContext(ThemeContext);
  const light = String(mode) === "light";
  const { t } = useTranslation();

  const navigate = useNavigate();
  function handleShowAllPendingAppointments() {
    navigate(PENDING_APPOINTMENTS);
  }

  return (
    <Paper
      sx={{
        p: 2,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        bgcolor: light ? "white" : "",
      }}
    >
      <Stack sx={{ pb: 2 }} direction={"row"} justifyContent={"space-between"}>
        <TitleWithIcon title={"PendingAppointments"}>
          <EventAvailable />
        </TitleWithIcon>
        <Box display="flex" alignItems="center" gap={2}>
          {count > 5 && !loading ? (
            <Typography variant="button" color={"gray"}>
              {appointments.length + "/" + count}
            </Typography>
          ) : null}

          {count > 5 && !loading && <Divider orientation="vertical" flexItem />}

          <Button
            variant="contained"
            onClick={() => handleShowAllPendingAppointments()}
          >
            {t("ShowMore")}
          </Button>
        </Box>
      </Stack>
      <Box sx={{ overflowY: "auto", flexGrow: 1 }}>
        <PendingAppointmentsHomePage
          refetch={refetch}
          loading={loading}
          appointments={appointments}
          error={error}
        />
      </Box>
    </Paper>
  );
}
